<template>
  <filter-summary
    icon="option"
    title="顧客接点"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>出力形式: {{ leafType }}</div>
    <div>追加表示項目: {{ additionalColumnCount }}項目</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'
import { LEAF_TYPE_LABELS } from '@/const/shin-tapir'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    type: {
      type: String,
      required: true,
    },
    columns: {
      type: Object,
      required: true,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    leafType() {
      return LEAF_TYPE_LABELS[this.type]
    },
    additionalColumnCount() {
      return this.columns[this.type].length
    },
  },
}
</script>
